import { useState } from 'react';
import { Sentry } from '@/lib/sentry';

export function SentryTestPage() {
  const [lastEventId, setLastEventId] = useState<string | null>(null);

  const sendMessage = () => {
    const id = Sentry.captureMessage(
      'Sentry test message from production',
      'info',
    );
    setLastEventId(id);
  };

  const sendError = () => {
    const id = Sentry.captureException(
      new Error('Sentry test error from production'),
    );
    setLastEventId(id);
  };

  const throwError = () => {
    // Throws inside React render cycle — caught by AppErrorBoundary → Sentry
    throw new Error('Sentry boundary test from production');
  };

  return (
    <div style={{ padding: 40, fontFamily: 'system-ui', maxWidth: 480 }}>
      <h1 style={{ marginBottom: 8 }}>Sentry Test</h1>
      <p style={{ color: '#666', marginBottom: 24 }}>
        Each button fires a different type of Sentry event. Check your Sentry
        dashboard after clicking.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <button onClick={sendMessage} style={btnStyle('#0070f3')}>
          Send message (info)
        </button>
        <button onClick={sendError} style={btnStyle('#f59e0b')}>
          Capture exception (manual)
        </button>
        <button onClick={throwError} style={btnStyle('#ef4444')}>
          Throw error (boundary capture)
        </button>
      </div>

      {lastEventId && (
        <p style={{ marginTop: 24, fontSize: 13, color: '#444' }}>
          Event sent — ID: <code>{lastEventId}</code>
          <br />
          Check Sentry Issues within 30 seconds.
        </p>
      )}
    </div>
  );
}

const btnStyle = (bg: string): React.CSSProperties => ({
  padding: '10px 16px',
  background: bg,
  color: '#fff',
  border: 'none',
  borderRadius: 8,
  fontSize: 14,
  cursor: 'pointer',
  textAlign: 'left',
});
